<template>
  <yxt-table
    ref="multipleTable"
    v-loading="loading"
    :data="customFilterDatas || customDatas"
    row-key="id"
    :border="border"
    style="width: 100%;"
    class="yxtbiz-eval-evaluator-table"
    @selection-change="handleSelectionChange"
  >
    <yxt-table-column
      v-if="multiple"
      type="selection"
      class-name="selection-col"
      reserve-selection
      :width="border ? 48 : 40"
    />
    <yxt-table-column
      prop="fullname"
      :label="$t('pc_gwnl_global_lbl_name')"
      width="300"
      v-if="tableType==='eval'"
    >
      <template slot-scope="scope">
        <div class="mb4 font-weight-600">
          <yxtbiz-user-name :name="scope.row.fullname" />
          ({{ scope.row.username }})
        </div>
        <div class="color-gray-7">
          {{ scope.row.positionName || '--' }}
        </div>
        <div class="color-gray-7">
          <dept-cell :dept-name="scope.row.deptName" />
        </div>
      </template>
    </yxt-table-column>
    <yxt-table-column
      prop="fullname"
      :label="$t('pc_gwnl_global_lbl_name')"
      width="150"
      v-if="tableType==='dynamic'"
    >
      <template slot-scope="scope">
        <div class="mb4 font-weight-600">
          <yxtbiz-user-name :name="scope.row.fullname" />
          ({{ scope.row.username }})
        </div>
      </template>
    </yxt-table-column>
    <yxt-table-column
      prop="positionName"
      label="岗位"
      width="150"
      v-if="tableType==='dynamic'"
    >
      <template slot-scope="scope">
        <div class="color-gray-7">
          {{ scope.row.positionName || '--' }}
        </div>
      </template>
    </yxt-table-column>
    <yxt-table-column
      prop="deptName"
      label="部门"
      width="150"
      v-if="tableType==='dynamic'"
    >
      <template slot-scope="scope">
        <div class="color-gray-7">
          <dept-cell :dept-name="scope.row.deptName" />
        </div>
      </template>
    </yxt-table-column>
    <yxt-table-column
      :label="$t('pc_gwnl_global_lbl_assessor')"
      class-name="gwnl-evaluator__td"
    >
      <template slot-scope="scope">
        <evaluator-cell
          :row="scope.row"
          :validate="validate"
          :showWeight="showWeight"
          :functionCode="functionCode"
          :dataPermissionCode="dataPermissionCode"
          :is-save="isSave"
          :id="id"
          :dynamicChoose="dynamicChoose"
          @update-evaluate="handleUpdateEvaluate($event, scope.row)"
        />
      </template>
    </yxt-table-column>
  </yxt-table>
</template>

<script>
import EvaluatorCell from './evaluator-cell';
import DeptCell from './deptCell';

export default {
  name: 'YxtbizEvalEvaluatorTable',
  name_zh: '测评评估人员列表',
  eventList: [{
    type: 'selection-change',
    handler: 'handleSelectionChange',
    label: '列表展示多选框时，选择的人员数据'
  }],
  components: {
    EvaluatorCell,
    DeptCell
  },
  props: {
    datas: {
      type: Array,
      desc: '列表里显示的人员数据',
      setter: 'JsonSetter'
    },
    loading: {
      type: Boolean,
      default: false,
      desc: '页面loading',
      setter: 'BooleanSetter'
    },
    // 是否展示评估百分比
    showWeight: {
      type: Boolean,
      default: true,
      desc: '是否展示评估百分比',
      setter: 'BooleanSetter'
    },
    // 表格是否支持多选
    multiple: {
      type: Boolean,
      default: true,
      desc: '表格是否支持多选',
      setter: 'BooleanSetter'
    },
    tableFilterData: {
      // 只用于table展示的数据（用于存在）
      type: Array,
      desc: '只用于table展示的数据（用于存在）',
      setter: 'JsonSetter'
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent',
      desc: '数据权限',
      setter: 'StringSetter'
    },
    functionCode: {
      type: String,
      default: 'gwnl_model_position',
      desc: '导航权限',
      setter: 'StringSetter'
    },
    isSave: {
      type: Boolean,
      default: false,
      desc: '是否针对人员处理要落库保存',
      setter: 'BooleanSetter'
    },
    id: {
      type: String,
      default: '',
      desc: '测评id',
      setter: 'StringSetter'
    },
    tableType: {
      type: String,
      default: 'eval', // eval-dynamic
      desc: '列表展示列的筛选，根据type判断',
      setter: 'TabSetter',
      enums: [{
        label: '测评',
        value: 'eval'
      }, {
        label: '表单',
        value: 'dynamic'
      }]
    },
    dynamicChoose: {
      type: Number,
      default: 0, // 默认胜任力测评
      desc: '加人、删人是否使用表单的接口',
      setter: 'TabSetter',
      enums: [{
        label: '使用表单接口',
        value: 1
      }, {
        label: '不使用表单接口',
        value: 0
      }]
    },
    border: {
      type: Boolean,
      default: false,
      desc: '是否展示表格的边框',
      setter: 'BooleanSetter'
    },
    // 是否只有自评
    isSelfTest: {
      type: Boolean,
      default: false,
      desc: '是否只有自评,可不校验每个评估关系是否都添加了人',
      setter: 'BooleanSetter'
    },
    // 评估关系的集合
    relationList: {
      type: Array,
      default: () => [],
      desc: '评估关系的集合',
      setter: 'JsonSetter'
    }
  },

  computed: {
    // 原数据处理
    customDatas() {
      return this.handleDataType(this.datas);
    },

    // 原筛选数据处理
    customFilterDatas() {
      return this.handleDataType(this.tableFilterData);
    }
  },

  data() {
    return {
      validate: true
    };
  },
  methods: {
    handleDataType(array) {
      if (array && array.length) {
        return array.map(item => {
          if (item.customRelation && item.customRelation.length) {
            item.customRelation.forEach(child => {
              this.$set(item, child.type, child);
            });
          }

          return item;
        });
      }

      return '';
    },

    handleSelectionChange(row) {
      if (this.multiple) {
        this.$emit('selection-change', row);
      }
    },
    // 校验页面的评估关系是否都为空
    validateDatas() {
      this.validate = true;
      if (this.isSelfTest) return true;

      // 所有的添加人员逻辑都在子组件判断，父组件这里只用判断是否存在评估人所有的评估关系为空的情况
      let processedData = JSON.parse(JSON.stringify(this.datas));

      let personEmptyList = [];
      processedData.forEach(item => {
        const evaluators = [];
        item.leaderRelation && evaluators.push(...(item.leaderRelation.evaluators || []));
        item.equalRelation && evaluators.push(...(item.equalRelation.evaluators || []));
        item.subordinateRelation && evaluators.push(...(item.subordinateRelation.evaluators || []));

        // 自定义人员添加
        (item.customRelation || []).forEach(child => {
          if (child.evaluators && child.evaluators.length) {
            evaluators.push(...child.evaluators);
          }
        });

        if (evaluators.length === 0) {
          personEmptyList.push(item.fullname);
        }
      });

      if (personEmptyList.length) {
        this.$message.error(this.relationList.join('、') + this.$t('pc_gwnl_eval_not_empy'));
        this.validate = false;
        return false;
      }
      return true;
    },

    handleUpdateEvaluate(obj, row) {
      const { key, rowId, val = [] } = obj;
      if (row.id === rowId && row[key]) {
        row[key].evaluators = val;
        this.$set(row[key], 'evaluators', val);
      }
    }
  }
};
</script>

<style lang="scss">
.yxt-table {
  td {
    &.gwnl-evaluator__td {
      padding: 0;
    }
  }
}
</style>
